<div class="outer-div">

  <!-- ================= PAGE TITLE ================= -->
  <ng-container *ngIf="viewMode === 'LIST'">
    <div class="label-bar">
      <label class="textColour" style="font-size: 18px; font-weight: 500;">
        HA Request Management
      </label>
      <span class="example-spacer"></span>
 <app-common-button
      title="Refresh"
      icon="fas fa-sync-alt"
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="loadAllData()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
    <app-common-button
      icon="fas fa-download"
      title="Download "
      [buttonId]="1111"
      [variant]="'cancel'"
      width="100%"
      padding="0rem 1rem"
      fontSize=".85rem"
      height="25px"
      (clicked)="onDownload()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
      <app-common-button
        label="Create"
        title="Create"
        icon="fas fa-plus-circle"
        [buttonId]="1111"
        [variant]="'cancel'"
        width="100%"
        padding="0rem 1rem"
        fontSize=".85rem"
        height="25px"
        (clicked)="onCreate()"
        style="margin-right:1%">
      </app-common-button>
    </div>

    <!-- ================= LIST VIEW ================= -->
    <!-- SUMMARY CARDS -->
    <div class="summary-row">
      <div class="summary-card">
        <span class="label">New</span>
        <span class="value">{{ newCount }}</span>
      </div>

      <div class="summary-card">
        <span class="label">In Progress</span>
        <span class="value">{{ inProgressCount }}</span>
      </div>

      <div class="summary-card">
        <span class="label">Completed</span>
        <span class="value">{{ completedCount }}</span>
      </div>

      <div class="summary-card">
        <span class="label">Cancelled</span>
        <span class="value">{{ cancelledCount }}</span>
      </div>
    </div>

    <!-- FILTERS + GRID -->
    <div style="width: 100%; margin-bottom: 5%;">
      <!-- AG GRID -->
      <ag-grid-angular
        style="margin-top: 2%; height: 55vh;"
        class="ag-theme-balham"
        [rowData]="rowData"
        [components]="components"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [suppressRowClickSelection]="true"
        [animateRows]="true"
        [paginationPageSize]="10"
        [pagination]="true"
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </ng-container>

  <!-- ================= FORM VIEW ================= -->
  <ng-container *ngIf="viewMode === 'FORM'">
    <app-ha-request-form
      [requestId]="selectedRequestId"
      [isViewOnly]="false"
      (back)="onBack()">
    </app-ha-request-form>
  </ng-container>

</div>